// @ts-nocheck
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { XIcon } from './icons';

/**
 * Drawer — slides in from a side. Default `side="right"`; pass `"left"` for
 * the mobile-nav case. Closes on ESC and scrim click.
 */
const Drawer = ({
  open,
  onClose,
  side = 'right',
  width = 320,
  title,
  actions,
  className = '',
  children,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  const isLeft = side === 'left';
  const sidePos = isLeft ? 'left-0' : 'right-0';
  const sidePanel = isLeft ? 'mov-drawer-panel-left' : 'mov-drawer-panel-right';

  return createPortal(
    <div
      className="mov-drawer-scrim fixed inset-0 z-[1000]"
      onClick={(e) => { if (e.target === e.currentTarget) onClose && onClose(); }}
    >
      <aside
        className={`mov-drawer-panel ${sidePanel} fixed top-0 bottom-0 flex flex-col ${sidePos} ${className}`}
        style={{ width, animation: `mov-drawer-${side} .18s ease-out` }}
      >
        <header className="flex items-center gap-2.5 pt-4 pb-3 px-[18px] border-b border-mov-line">
          <b className="flex-1 text-[14px] font-semibold">{title}</b>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="bg-transparent border-0 text-mov-ink-mute hover:text-mov-ink cursor-pointer"
          >
            <XIcon size={16} />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto py-3.5 px-[18px]">
          {children}
        </div>
        {actions && (
          <div className="flex gap-2 shrink-0 py-3 px-[18px] border-t border-mov-line bg-mov-paper-2">
            {actions}
          </div>
        )}
      </aside>
    </div>,
    document.body,
  );
};

export default Drawer;
